module.exports = __webpack_public_path__ + "static/media/live-online-mockup.86df3cfd.png";